import { Controller } from "@hotwired/stimulus";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default class extends Controller {
  static values = {
    data: Object,
    period: String,
  };

  connect() {
    this.createChart();
  }

  dataValueChanged() {
    if (this.chart) {
      this.updateChart();
    }
  }

  createChart() {
    const ctx = this.element;
    const chartData = this.dataValue;
    const period = this.periodValue || "day";

    // Convert the data object to arrays for Chart.js
    const labels = Object.keys(chartData);
    const data = Object.values(chartData);

    // Format labels based on period
    const formattedLabels = labels.map((label) => {
      const date = new Date(label);
      switch (period) {
        case "day":
          return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
        case "week":
          return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
        case "month":
          return date.toLocaleDateString("en-US", {
            month: "short",
            year: "numeric",
          });
        default:
          return label;
      }
    });

    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: formattedLabels,
        datasets: [
          {
            label: "User Signups",
            data: data,
            borderColor: "rgb(99, 102, 241)",
            backgroundColor: "rgba(99, 102, 241, 0.1)",
            borderWidth: 2,
            fill: true,
            tension: 0.4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: "index",
        },
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0,
            },
          },
        },
      },
    });
  }

  updateChart() {
    if (!this.chart) return;

    const chartData = this.dataValue;
    const period = this.periodValue || "day";

    const labels = Object.keys(chartData);
    const data = Object.values(chartData);

    const formattedLabels = labels.map((label) => {
      const date = new Date(label);
      switch (period) {
        case "day":
          return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
        case "week":
          return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
        case "month":
          return date.toLocaleDateString("en-US", {
            month: "short",
            year: "numeric",
          });
        default:
          return label;
      }
    });

    this.chart.data.labels = formattedLabels;
    this.chart.data.datasets[0].data = data;
    this.chart.update();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
